import React, { useRef } from "react";

import Button from "../../Buttons/Button";

const CustomFileInputButton = ({
  title,
  size,
  onChange,
  multiple,
  accept,
  placeholder,
  value,
  disabled,
  color,
}) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    if (onChange && e.target.files) {
      // Pass the files array directly instead of the event
      onChange(Array.from(e.target.files));
    }
  };

  return (
    <div>
      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileChange}
        multiple={multiple}
        accept={accept}
        disabled={disabled}
      />
      <Button
        title={title || "Upload"}
        icon={"upload"}
        size={size}
        onClick={handleButtonClick}
        disabled={disabled}
        color={color}
      />
    </div>
  );
};

export default CustomFileInputButton;
